import { $$ } from '../lib/domUtils';

const filters = $$('.js-filter-bar');

filters.forEach(filter => {
  filter.addEventListener('change', () => {
    window.location.assign(filter.value);
  });
});
